import React, { useEffect, useState } from 'react'
import "./LoginPage.scss";
import { useLoginUserMutation } from '../API/UserApi';
import apiResponse from '../Interfaces/apiResponse';
import { useNavigate } from 'react-router-dom';
import Loader from '../Helper/Loader';
interface props{
    onLogin: boolean
}
function LoginPage({onLogin}:props) {
    const storedJsonString = localStorage.getItem('QuizCredentials');
    const hasLocalStorageData = !!localStorage.getItem('QuizCredentials');
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loginUser] = useLoginUserMutation();
    const [isRemembered, setIsRemembered] = useState(false);
    const [loading, setLoading] = useState(false);
    const [userInput,setUserInput] = useState({
    userName:"",
    passwordHash:"",
    });
    useEffect(() => {
        if(hasLocalStorageData){
        navigate('/');
        }
    }, []); 
    const handleCreate = async () =>{
      navigate("/user/create");
    }


    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
        setLoading(true);
    
   
    const response: apiResponse = await loginUser({
        userName:email,
        passwordHash:password,
        isRemembered:isRemembered
    });
        if(response.data?.isSuccess == true){
        const jsonString = JSON.stringify(response.data.result);
        localStorage.setItem("QuizCredentials",jsonString);
        const storedJsonData = JSON.parse(jsonString);
        navigate("/home");
    }else if(response.data?.isSuccess == false) {
        navigate("/");
    }
        setLoading(false);
    } 
   
    
    return (
    <div className="login-page">
      <div className="login-card">
        <h1 className="title">Welcome Back</h1>
        <p className="subtitle">Login to your account</p>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email</label>
            <input
              type="text"
              placeholder="Enter your email or UserName"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <div className="options">
            <label>
              <input type="checkbox" 
               checked={isRemembered}
               onChange={(e) => setIsRemembered(e.target.checked)}
              /> Remember me
            </label>
            <a href="#">Forgot password?</a>
          </div>
         
          <button type="submit" className="login-btn">
            Login
          </button>
        </form>
         <div><a href="#" onClick={() => handleCreate()} className="create-btn">Create Account</a> </div>
      </div>
      {loading && <Loader/>}
    </div>
  )
}

export default LoginPage